import * as React from 'react';
import { Button } from 'antd';
import { Link } from 'react-router-dom';
// import './index.less';

const ErrorPage = () => (
  <div className="error-container">
    <p />
    <div>
      <h2>404</h2>
      <p>抱歉,你访问的页面不存在</p>
      <Button type="primary">
        <Link to="/">返回首页</Link>
      </Button>
    </div>
  </div>
);

export default ErrorPage;



// WEBPACK FOOTER //
// ./src/components/views/ErrorPage.tsx